export const stringMapDefault = {
    editIconTitle: "Edit",
    confirmIconTitle: "Confirm",
    cancelIconTitle: "Cancel"
};
